import { z } from 'zod';

export const ehrResourceSchema = z.enum([
  'patient',
  'encounter',
  'referral',
  'orders',
  'claim',
  'customEhrData',
]);

export const EHRResource = ehrResourceSchema.enum;

export type EHRResource = z.infer<typeof ehrResourceSchema>;
